const apiConfig = {
    API_URL: (process.env.NODE_ENV === 'production') ? "https://recapi.yanpix.com" : "http://localhost:3000"
};

export default apiConfig;